import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const historicoParceiroStyles = {
  Container: styled(Box)`
    padding: 12px;
  `
}
